import { GET_ALL_CONFERENCES, GET_REPORT_DATA } from './mutation-types'

export default {
  [GET_ALL_CONFERENCES]: (state, conferencias) => {
    state.conferencias = conferencias
  },
  [GET_REPORT_DATA]: (state, dadosRelatorioConferencia) => {
    state.dadosRelatorioConferencia = dadosRelatorioConferencia
  },
}
